import { atom } from "recoil";

const difficultyKeysState = atom({
  key: "difficultyKeysState",
  default: null,
});

export default difficultyKeysState;
